import { axios } from "~/plugins/request";
export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  findBasicConfigData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/report/initialPlan/findBasicConfigData`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  saveOrUpdateField({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/configPlanField/saveOrUpdateField`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getDictionary({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "/fwxtdictionary/findAllItemByTypeCode",
        params: params
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getSchemeDetailEdit({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/shanghaiPlan/selectProgramInfoEdit`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findUniversityQueryList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/shanghaiPlan/findUniversityQueryList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findSchemeList({ commit }, params) {
    return new Promise((resolve, reject) => {
      try {
        axios({
          method: "post",
          url: "/shanghaiPlan/selectSchemeList",
          data: params
        })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      } catch (e) {
        console.log(e);
      }
    });
  },
  findProfessionList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/shanghaiPlan/findProfessionList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  save({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/shanghaiPlan/save`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getSchemeDetail({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/shanghaiPlan/selectProgramInfo`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteCondition({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`login/getUserDeleteLimits`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  saveLeaveMessage({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/report/initialPlan/saveLeaveMessage`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  sendScheme({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/report/initialPlan/sendScheme`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  remove({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/report/initialPlan/remove`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  schemeInspect({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/report/smartReport/inspect`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  exportScheme({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "/shanghaiPlan/exportScheme",
        data: params,
        responseType: "blob",
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  saveAndSend({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/report/initialPlan/sendScheme`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  recommendScheme({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`report/finalPlan/updateRecommendStatus`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  designThoughtSave({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/report/initialPlan/updateSchemeDesignThought`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findIdBySpecialityName({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/profession/findIdBySpecialityName`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getUserDeleteLimits({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/login/getUserDeleteLimits`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getUniversityId({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/university/findIdByUniversityName`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getPDF({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/report/estimatePlan/findExportById`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getPDF_shanDong({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/report/newPlan/findExportById`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getPDF_shanghaiPlan({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/shanghaiPlan/findExportById`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findExportUrlById_shanghaiPlan({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
      .get(`/shanghaiPlan/findExportUrlById`, { params })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
    });
  },
  getPDF_estimatePlan({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/report/estimatePlan/findExportById`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findExportUrlById_estimatePlan({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
      .get(`/report/estimatePlan/findExportUrlById`, { params })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
    });
  },
  getPDF_newPlan({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/report/newPlan/findExportById`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findExportUrlById_newPlan({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
      .get(`/report/newPlan/findExportUrlById`, { params })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
    });
  },
  findExportUrlById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
      .get(`/report/newPlan/findExportUrlById`, { params })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
    });
  },
};
